import { render } from "./ColApp.vue?vue&type=template&id=5101dab8"
import script from "./ColApp.vue?vue&type=script&lang=js"
export * from "./ColApp.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__